import { render, staticRenderFns } from "./provision-tcr.vue?vue&type=template&id=0f7837ae&scoped=true&"
import script from "./provision-tcr.vue?vue&type=script&lang=js&"
export * from "./provision-tcr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7837ae",
  null
  
)

export default component.exports